import {useTranslation} from 'next-i18next';

export default function SupportTile({type, text, src, subTitle}) {
  const {t: translateCommon} = useTranslation('common');

  const icon = type === 'document' ?
      <svg className="w-6 h-6 text-gray-500" fill="none" stroke="currentColor"
           viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
      </svg> :
      <svg className="w-6 h-6 text-red-500" fill="none" stroke="currentColor"
           viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
      </svg>;

  const callToAction = type === 'document' ?
      translateCommon('DOWNLOAD') :
      translateCommon('STREAM');

  return (
      <a href={src} download target="_blank" rel="noopener noreferrer">
        <div className={'flex flex-row my-5 text-red-600'}>
          <div className={'h-7 w-7'}> {icon}</div>
          <div className={'ml-4'}>
            <p className={'text-black font-bold'}>
              {callToAction}
            </p>
            <p className={'text-gray-600 text-sm'}>
              — {subTitle}
            </p>
          </div>
        </div>
      </a>
  );
}